module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Light-Alphabetic.2c7c07ea.woff2";